// extracted by mini-css-extract-plugin
export default {"congratulations":"congratulations_congratulations__hBVDV","button":"congratulations_button__ZMpFV"};